var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.isSettingsReady)?_c('card-edit',{on:{"edit":function($event){return _vm.$emit('edit')}}},[_c('order-location',{attrs:{"order":_vm.$store.getters.orderSystem.order,"divider":"","flat":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }